// Regional-focus SEO — city "Home Services" pillar pages (/home-services/:citySlug).
// A pillar is a hub that targets the broad head query ("home services <city>") and links DOWN to that
// city's individual service pages, concentrating internal-link equity on the zone. Only cities that
// have REAL published service pages under a matching {slug}-{state} path are listed here, so every
// pillar link resolves (no 404s). Excluded on purpose: wilmington (mislabeled 'NC' in SeoCity, its
// pages live at wilmington-nc not wilmington-de) and brooklyn (no published SeoCity). See [[indexZone]].

export const PILLAR_CITIES = [
  { slug: 'philadelphia', state: 'PA', name: 'Philadelphia' },
  { slug: 'newark', state: 'NJ', name: 'Newark' },
  { slug: 'new-york', state: 'NY', name: 'New York' },
  { slug: 'jersey-city', state: 'NJ', name: 'Jersey City' },
  { slug: 'trenton', state: 'NJ', name: 'Trenton' },
  { slug: 'paterson', state: 'NJ', name: 'Paterson' },
  { slug: 'elizabeth', state: 'NJ', name: 'Elizabeth' },
  { slug: 'edison', state: 'NJ', name: 'Edison' },
  { slug: 'yonkers', state: 'NY', name: 'Yonkers' },
  { slug: 'allentown', state: 'PA', name: 'Allentown' },
  { slug: 'reading', state: 'PA', name: 'Reading' },
];

// Curated top home-improvement services (all verified published for every pillar city). Slugs must
// match real SeoLandingPage paths — the pillar links to /services/{slug}/{citySlug}-{state}.
export const PILLAR_SERVICES = [
  { slug: 'handyman', label: 'Handyman' },
  { slug: 'cleaning', label: 'House Cleaning' },
  { slug: 'plumbing', label: 'Plumbing' },
  { slug: 'electrical', label: 'Electrical' },
  { slug: 'painting', label: 'Painting' },
  { slug: 'hvac', label: 'HVAC & Heating' },
  { slug: 'moving-and-hauling', label: 'Moving & Hauling' },
  { slug: 'furniture-assembly', label: 'Furniture Assembly' },
  { slug: 'tv-mounting', label: 'TV Mounting' },
  { slug: 'yard-work', label: 'Yard Work & Lawn Care' },
  { slug: 'pressure-washing', label: 'Pressure Washing' },
  { slug: 'junk-removal', label: 'Junk Removal' },
  { slug: 'drywall-repair-installation', label: 'Drywall Repair' },
  { slug: 'flooring-and-tile', label: 'Flooring & Tile' },
  { slug: 'appliance-repair', label: 'Appliance Repair' },
  { slug: 'pest-control-and-environmental', label: 'Pest Control' },
  { slug: 'roofing-and-gutters', label: 'Roofing & Gutters' },
  { slug: 'carpentry-woodwork', label: 'Carpentry & Woodwork' },
];

export function pillarCityBySlug(slug) {
  const s = String(slug || '').toLowerCase();
  return PILLAR_CITIES.find((c) => c.slug === s) || null;
}

// Path to a city×service SEO page for a pillar city, e.g. ('handyman', {slug:'philadelphia',state:'PA'})
// -> '/services/handyman/philadelphia-pa'.
export function servicePath(serviceSlug, city) {
  return `/services/${serviceSlug}/${city.slug}-${city.state.toLowerCase()}`;
}

// All pillar page paths (for the sitemap).
export function pillarPaths() {
  return PILLAR_CITIES.map((c) => `/home-services/${c.slug}`);
}
